import { render, staticRenderFns } from "./evaluateProposalv1.0.vue?vue&type=template&id=609a5722&scoped=true"
import script from "./evaluateProposalv1.0.vue?vue&type=script&lang=js"
export * from "./evaluateProposalv1.0.vue?vue&type=script&lang=js"
import style0 from "./evaluateProposalv1.0.vue?vue&type=style&index=0&id=609a5722&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609a5722",
  null
  
)

export default component.exports